import React from "react";

const Spinner = ({ className, ...props }) => <div className={`h-7 w-7 animate-spin rounded-full border-2 border-t-2 border-grey-500 border-t-grey-100 ${className}`} {...props} />;
export default Spinner;
